<template>
  <div class="rollLegendContent" :id="chartID">
    <div class="rollTimesBox" v-if="legendType == 1">
      <div v-for="index of xLength" :key="index" class="colorSpanStand">
        <div class="colorBlock">
          <span
            :style="'background:' + rollColor[yNum * (index - 1) + 1]"
          ></span>
          <span :style="fontStyle">{{ yNum * (index - 1) + 1 }}</span>
        </div>
        <div class="colorBlock"  v-show="rollColor[yNum * (index - 1) + 2] != undefined">
          <span
            :style="'background:' + rollColor[yNum * (index - 1) + 2]"
          ></span>
          <span
            :style="fontStyle"
           
            >{{ yNum * (index - 1) + 2 }}</span
          >
        </div>
        <div class="colorBlock"  v-show="rollColor[yNum * (index - 1) + 3] != undefined">
          <span
            :style="'background:' + rollColor[yNum * (index - 1) + 3]"
          ></span>
          <span
            :style="fontStyle"
           
            >{{ yNum * (index - 1) + 3 }}</span
          >
        </div>
        <div class="colorBlock"  v-show="rollColor[yNum * (index - 1) + 4] != undefined">
          <span
            :style="'background:' + rollColor[yNum * (index - 1) + 4]"
          ></span>
          <span
            :style="fontStyle"
         
            >{{ yNum * (index - 1) + 4 }}</span
          >
        </div>
      </div>
    </div>
    <div class="rollIcvContent spanBig" v-else-if="legendType == 5 || legendType == 6">
      <div v-for="index of xLength" :key="index" class="colorSpanStand2">
        <div class="colorBlock2">
          <span
            :style="'background:' + rollColor[keys[yNum * (index - 1)]]"
          ></span>
          <span :style="fontStyle">{{
            getRollIcvTxt(yNum * (index - 1))
          }}</span>
        </div>
        <div class="colorBlock2"   v-show="keys[yNum * (index - 1) + 1] != undefined">
          <span
            :style="'background:' + rollColor[keys[yNum * (index - 1) + 1]]"
          ></span>
          <span
            :style="fontStyle"
          
            >{{ getRollIcvTxt(yNum * (index - 1) + 1) }}</span>
        </div>
           
        <div class="colorBlock2" v-show="keys[yNum * (index - 1) + 2] != undefined" >
          <span
            :style="'background:' + rollColor[keys[yNum * (index - 1) + 2]]"
          ></span>
          <span
            :style="fontStyle"
            >{{ getRollIcvTxt(yNum * (index - 1) + 2) }}</span
          >
        </div>
      </div>
    </div>
    <div class="rollIcvContent" v-else>
      <div v-for="index of xLength" :key="index" class="colorSpanStand2">
        <div class="colorBlock2">
          <span
            :style="'background:' + rollColor[keys[yNum * (index - 1)]]"
          ></span>
          <span :style="fontStyle">{{
            getRollIcvTxt(yNum * (index - 1))
          }}</span>
        </div>
        <div class="colorBlock2"   v-show="keys[yNum * (index - 1) + 1] != undefined">
          <span
            :style="'background:' + rollColor[keys[yNum * (index - 1) + 1]]"
          ></span>
          <span
            :style="fontStyle"
          
            >{{ getRollIcvTxt(yNum * (index - 1) + 1) }}</span>
        </div>
           
        <div class="colorBlock2" v-show="keys[yNum * (index - 1) + 2] != undefined" >
          <span
            :style="'background:' + rollColor[keys[yNum * (index - 1) + 2]]"
          ></span>
          <span
            :style="fontStyle"
            >{{ getRollIcvTxt(yNum * (index - 1) + 2) }}</span
          >
        </div>
      </div>
    </div>

    <div class="colorSpanBottom" :class="isRollIcv" v-show="false">
      <span class="colorSpanTitle" :style="fontStyle">{{ colorSpanTitle }}</span
      ><span :style="colorStickStyle" class="colorStick"></span>
    </div>
  </div>
</template>

<script>
import html2canvas from 'html2canvas';
export default {
  data() {
    return {
      colorList: [],
      rollColor: {},
      tempColor:{},
      xLength: 0,
      yNum: 3,
      colorSpanTitle: "",
      colorStickStyle:
        "background-image: linear-gradient(to right,red,yellow);",
      keys: [],
      fontStyle: "color:" + this.fontColor,
      chartID: this.uuid(),
    };
  },
  props: {
    legendType: {
      type: String,
      default: function () {
        return "1";
      },
    },
    fontColor: {
      type: String,
      default: function () {
        return "black";
      },
    },
  },
  computed: {
    isRollIcv: function () {
      if (this.legendType == "1") {
        //碾压遍数
        return "";
      } else if (this.legendType == "2") {
        //压实度
        return "moreUp";
      } else {
        return "";
      }
    },
    isRollNumColorChanged: function () {
      return this.$store.state.rollNumColorArr;
    },
    isRollIcvColorChanged: function () {
      return this.$store.state.icvColorArr;
    },
    isRollTempColorChanged: function () {
      return this.$store.state.rollColorArr;
    },
  },
  watch: {
    isRollNumColorChanged() {
      if (this.legendType == "1") {
        this.rollColor = this.$store.state.rollNumColor;
        this.yNum = 4;
        this.colorList = this.$store.state.rollNumColorArr;
        this.colorStickStyle = this.getBackgroundStyle(this.colorList);
        this.xLength = Math.ceil(this.colorList.length / this.yNum);
        this.colorSpanTitle = "遍数色阶";
        this.canvas2Img();
      }
    },
    isRollIcvColorChanged() {
      if (this.legendType == "2") {
        this.rollColor = this.$store.state.icvColor;
        console.log(this.rollColor,'rollColor')
        this.yNum = 3;
        this.colorList = this.$store.state.icvColorArr;
        this.colorSpanTitle = "压实度色阶";
        this.colorStickStyle = this.getBackgroundStyle(this.colorList);
        this.xLength = Math.ceil(this.colorList.length / this.yNum);
        let keys = Object.keys(this.rollColor);
        this.keys = keys;
        this.canvas2Img();
      }
    },
    isRollTempColorChanged() {
      if (this.legendType == "4") {
        this.rollColor = this.$store.state.rollColor;
        console.log(this.rollColor,'rollColor')
        this.yNum = 3;
        this.colorList = this.$store.state.rollColorArr;
        this.colorSpanTitle = "碾压温度色阶";
        this.colorStickStyle = this.getBackgroundStyle(this.colorList);
        this.xLength = Math.ceil(this.colorList.length / this.yNum);
        let keys = Object.keys(this.rollColor);
        this.keys = keys;
        this.canvas2Img();
      }
    },
  },
  mounted() {
    let colorList = null;
    if (this.legendType == "1") {
      //遍数
      colorList = this.$store.state.rollNumColorArr;
      this.rollColor = this.$store.state.rollNumColor;
      this.yNum = 4;
      this.xLength = Math.ceil(colorList.length / this.yNum);
      this.colorSpanTitle = "遍数色阶";
    } else if (this.legendType == "2") {
      console.log('压实度')
      //压实度
      colorList = this.$store.state.icvColorArr;
      this.yNum = 3;
      this.xLength = Math.ceil(colorList.length / this.yNum);
      this.rollColor = this.$store.state.icvColor;
      this.colorSpanTitle = "压实度色阶";
      let keys = Object.keys(this.rollColor);
      this.keys = keys;
    }else if (this.legendType == "3") {
      console.log('摊铺温度')
      //压实度
      colorList = this.$store.state.pavColorArr;
      this.yNum = 3;
      this.xLength = Math.ceil(colorList.length / this.yNum);
      this.rollColor = this.$store.state.pavColor;
      this.colorSpanTitle = "摊铺温度色阶";
      let keys = Object.keys(this.rollColor);
      this.keys = keys;
    }else if (this.legendType == "4") {
      //压实度
      colorList = this.$store.state.rollColorArr;
      this.yNum = 3;
      this.xLength = Math.ceil(colorList.length / this.yNum);
      this.rollColor = this.$store.state.rollColor;
      this.colorSpanTitle = "碾压温度色阶";
      let keys = Object.keys(this.rollColor);
      this.keys = keys;
    }else if (this.legendType == "5") {
      console.log('摊铺高程')
      //摊铺高程
      colorList = this.$store.state.elevationColorArr;
      this.yNum = 3;
      this.xLength = Math.ceil(colorList.length / this.yNum);
      this.rollColor = this.$store.state.elevationColor;
      this.colorSpanTitle = "摊铺高程色阶";
      let keys = Object.keys(this.rollColor);
      this.keys = keys;
    }else if (this.legendType == "6") {
      console.log('平整度')
      //平整度
      colorList = this.$store.state.evennessColorArr;
      this.yNum = 3;
      this.xLength = Math.ceil(colorList.length / this.yNum);
      this.rollColor = this.$store.state.evennessColor;
      this.colorSpanTitle = "平整度程色阶";
      let keys = Object.keys(this.rollColor);
      this.keys = keys;
    }
    this.colorList = colorList;
    this.colorStickStyle = this.getBackgroundStyle(this.colorList);
this.canvas2Img();
  },
  methods: {
    canvas2Img(){
      this.$nextTick(()=>{
        // console.log(this.colorList,this.colorStickStyle,"document.getElementById(this.chartID)")
        html2canvas(document.getElementById(this.chartID),{useCORS:true,allowTaint: false,backgroundColor:null}).then(canvas=>{
          let timer=setTimeout(()=>{
            let url = canvas.toDataURL('image/png');
            // console.log(url,this.legendType)
            let screenshots = new Image();
            screenshots.src = url
            this.$emit('childExam',screenshots)
            clearTimeout(timer)
          },1000)
        })
      })
    },
    getBackgroundStyle(colorList) { 
      if(colorList.length==1){
        //只有一种颜色
        return "background:"+colorList[0]+";";
      }
      var styleStr = "background-image: linear-gradient(to right,";
      for (var i = 0; i < colorList.length; i++) {
        styleStr += colorList[i];
        if (i != colorList.length - 1) {
          styleStr += ",";
        }
      }
      styleStr += ");";
      return styleStr;
    },
    getRollIcvTxt(num) {
      let unit = ''
      if(this.legendType == '4' || this.legendType == '3'){
        unit = '℃'
      }
      if(this.legendType == '5' || this.legendType == '6'){
        unit = 'mm'
      }
      if(this.legendType == '5' || this.legendType == '6'){
        if (num == 0) {
          //第一个
          return "≤" + this.keys[num] + ' ' + unit;
        } else if(num == this.keys.length-1){
          return "＞" + parseInt(this.keys[num - 1]) + unit;
        } else {
          return parseInt(this.keys[num - 1]) + 1 + "~" + this.keys[num] + unit;
        }
      }else{
        if (num == 0) {
          //第一个
          return "0~" + this.keys[num];
        } else {
          return parseInt(this.keys[num - 1]) + 1 + "~" + this.keys[num] + unit;
        }
      }
      
    },
  },
};
</script>

<style lang="scss">
.colorBlock {
  width: 60px;
  height: 20px;
}
.colorBlock > span {
  display: inline-block;
  width: 20px;
  height: 20px;
}
.colorBlock2 {
  width: 80px;
  height: 20px;
  display: flex;
}
.colorBlock2 > span:nth-child(1) {
  display: inline-block;
  width: 20px;
  height: 20px;
  margin-right: 10px;
}
.colorBlock2 > span:nth-child(2) {
  display: inline-block;
  width: 40px;
  height: 20px;
}
.colorStick {
  width: 200px;
  height: 20px;
  margin-left: 10px;
  display: inline-block;
}
.colorSpanStand {
  height: 100px;
  width: 60px;
  display: inline-block;
}
.colorSpanStand2 {
  height: 100px;
  width: 120px;
  display: inline-block;
}
.rollIcvContent {
  width: 100%;
  position: relative;
  top: 10px;
}
.spanBig{
  .colorBlock2{
    width: 120px !important;
    display: flex;
  }
  .colorBlock2> span:nth-child(2) {
    display: inline-block;
    width: 80px !important;
    height: 20px;
    line-height: 20px;
  }
}

.rollLegendContent {
  width: 360px;
  height: 100px;
}
.rollLegendContent > div {
  width: 100%;
  text-align: center;
}
.colorSpanTitle {
  height: 20px;
  position: relative;
  bottom: 4px;
}
.colorSpanBottom {
  height: 20px;
  position: absolute;
  bottom: 0px;
}
.moreUp {
  position: relative;
  bottom: 10px;
}
</style>